// =============================================================================
// Optim TURPE V2 : amener un champ à l'écran après l'ouverture des panneaux
// (rejeu du 20/10/2026, A8).
//
// Ce que le client doit vivre : « Chiffrer d'autres puissances » met le
// curseur dans la première puissance ET la montre à l'écran.
//
// Le geste ouvre d'abord la rangée « Hypothèses de l'étude », dont le contenu
// se déplie en s'animant (hauteur qui grandit, débordement masqué). Le
// défilement fait pendant l'animation porte sur ce contenu masqué, pas sur la
// page ; l'animation finie, le champ retombait sous la fenêtre (mesuré à
// 1 216 px de haut pour une fenêtre de 900). On attend donc la fin des
// animations en cours, puis, seulement si le champ n'est pas entièrement
// visible, on le centre : aucun saut quand il l'est déjà.
// =============================================================================

/** Au-delà, on n'attend plus une animation (elle ne finira pas). */
const ATTENTE_MAX_MS = 1500

function prochaineImage(): Promise<void> {
    return new Promise((fin) => {
        if (typeof requestAnimationFrame === "function")
            requestAnimationFrame(() => fin())
        else setTimeout(fin, 16)
    })
}

/** Le champ est-il entièrement dans la fenêtre ? */
export function estEntierementVisible(champ: Element): boolean {
    const r = champ.getBoundingClientRect()
    const hauteur =
        window.innerHeight || document.documentElement.clientHeight || 0
    return r.top >= 0 && r.bottom <= hauteur
}

/** Les animations en cours d'un parent du champ (son ouverture). */
function ouverturesEnCours(champ: Element): Animation[] {
    if (typeof document.getAnimations !== "function") return []
    return document.getAnimations().filter((a) => {
        if (a.playState !== "running") return false
        const cible = (a.effect as KeyframeEffect | null)?.target
        return cible instanceof Element && cible.contains(champ)
    })
}

/**
 * Attend la fin des ouvertures animées autour du champ (bornée), puis centre
 * le champ s'il n'est pas entièrement visible. Vue pose la transition une
 * image après l'ouverture : on regarde sur deux images avant de conclure
 * qu'aucune ne joue. Sans `document.getAnimations` (environnement de test,
 * navigateur ancien), seul le contrôle final a lieu.
 */
export async function amenerALEcranApresLesOuvertures(
    champ: HTMLElement | null | undefined
): Promise<void> {
    if (!champ) return
    const debut = Date.now()
    await prochaineImage()
    await prochaineImage()
    let enCours = ouverturesEnCours(champ)
    while (enCours.length > 0) {
        const reste = ATTENTE_MAX_MS - (Date.now() - debut)
        if (reste <= 0) break
        await Promise.race([
            Promise.allSettled(enCours.map((a) => a.finished)),
            new Promise((fin) => setTimeout(fin, reste)),
        ])
        await prochaineImage()
        enCours = ouverturesEnCours(champ)
    }
    if (!champ.isConnected || estEntierementVisible(champ)) return
    if (typeof champ.scrollIntoView === "function")
        champ.scrollIntoView({ block: "center" })
}
